<template>
  <div>Card Event</div>
</template>

<script setup lang="ts">
import type { TypeAsideCardWithoutUnresolvableLinksResponse } from '~/types/contentful'

// Props
defineProps<{
  data: TypeAsideCardWithoutUnresolvableLinksResponse
}>()
</script>
